export const typeDefs = `
  union NotificationType = success | fail | info

  input NotificationInput {
    delayInterval: Int
    type: NotificationType
    message: String!
  }
`;
